import styled, { css } from 'styled-components'

export const Date = styled.p`
  ${({ theme: { font }}) => css`
    font-family: ${font.en};
    font-size: 2.2rem;
    font-weight: 500;
  `}
`

export const Week = styled.span`
  ${({ theme: { font }}) => css`
    font-family: ${font.en};
    font-size: 1.2rem;
    font-weight: 100;
  `}
`